import { render, staticRenderFns } from "./add-strategy.vue?vue&type=template&id=507946d0&scoped=true"
import script from "./add-strategy.vue?vue&type=script&lang=ts"
export * from "./add-strategy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507946d0",
  null
  
)

export default component.exports